//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { MouseEvent } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

interface SkipLinkProps {
  href: string;
  text: string;
}

const SkipLink = ({ href, text }: SkipLinkProps) => {
  const theme = useTheme();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const targetElement = document.querySelector<HTMLElement>(href);
    if (targetElement) {
      // Ensure the element is focusable.
      targetElement.setAttribute('tabindex', '-1');
      targetElement.focus();
    }
  };

  return (
    <Box
      component="a"
      href={href}
      onClick={handleClick}
      sx={{
        position: 'absolute',
        top: '-40px',
        left: 0,
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: '8px',
        zIndex: 100,
        textDecoration: 'none',
        '&:focus': {
          top: 0,
        },
      }}
    >
      {text}
    </Box>
  );
};

export default SkipLink;
